export var QUIZ_WIDGET = "quiz_widget"
export var GOALS_WIDGET = "goals_widget"
export var BOOK_WIDGET = "book_widget"
export var WRITING_WIDGET = "writing_widget"

// METRICS AND LOOKUP KEYS
export var TOTAL_QUIZZES = 'total_quizzes'
export var FAILED_QUIZZES = 'failed_quizzes'
export var FLAGGED_QUIZZES = 'flagged_quizzes'
export var GOALS_COMPLETE = 'students_complete'
export var GOALS_ON_PACE = 'students_on_pace'
export var GOALS_BEHIND = 'students_behind'
export var AVERAGE_LEXILE_LEVEL = 'average_lexile_level'
export var MINUTES_LOGGED = 'minutes_logged'
export var TOTAL_BOOKS = 'uniq_book_count'
export var FLAGGED_BOOKS = 'flagged_books'
export var TOTAL_PRACTICE_QUESTIONS = 'total_practice_questions'
export var TOTAL_QUESTION_BUILDERS = 'total_question_builders'
export var TOTAL_REVIEWS = 'total_reviews'
export var EXCERCISES_COMPLETED = 'excercises_completed'
export var AVERAGE_QUIZ_SCORE = 'average_quiz_score'

// UNIQUE LOOKUP KEYS
export var NEW_QUIZZES = 'new_quizzes'
export var YEARLY_TOTAL_QUIZZES = 'yearly_total_quizzes'
export var QUIZZES_PASSED_GOAL = 'quizzes-passed_goal'
export var QUESTIONS_GOAL = 'questions_goal'
export var REVIEWS_GOAL = 'reviews_goal'
export var EXERCISES_GOAL = 'exercises_goal'
export var MINUTES_GOAL = 'minutes_goal'
export var DAYS_ACTIVE_GOAL = 'days-active_goal'
export var PAGES_GOAL = 'pages_goal'
export var QUESTION_BUILDERS_GOAL = 'question-builder_goal'

// SECONDARY METRICS
export var TIME_PERIOD = 'time_period'

// USER TYPES
var STUDENT = 'Student'
var ADMIN = 'Admin'

export var CONFIG = {
  //// ADMINS ////
  [ADMIN]: [
    {
      font_color: 'green',
      icon: 'confetti',
      title: 'New Quizzes',
      singular_title: 'New Quiz',
      primary_metric: TOTAL_QUIZZES,
      lookup_key: NEW_QUIZZES,
      current_metric: true,
      secondary_metric: TIME_PERIOD,
      link: {
        text: 'View',
        build_link: true,
        base: '/data/everyone/quizzes?order=completed_at_desc&list=everyone'
      }
    },
    {
      font_color: 'red',
      icon: 'cancel',
      title: 'Failed Quizzes',
      singular_title: 'Failed Quiz',
      primary_metric: FAILED_QUIZZES,
      lookup_key: FAILED_QUIZZES,
      secondary_metric: TIME_PERIOD,
      link: {
        text: 'View',
        build_link: true,
        base: '/data/everyone/quizzes?status=failed&order=completed_at_desc&student_list=everyone'
      },
    },
    {
      font_color: 'red',
      icon: 'flag',
      title: 'Flagged Quizzes',
      singular_title: 'Flagged Quiz',
      primary_metric: FLAGGED_QUIZZES,
      lookup_key: FLAGGED_QUIZZES,
      secondary_metric: TIME_PERIOD,
      link: {
        text: 'View',
        build_link: true,
        base: '/data/everyone/quizzes?status=flagged&order=completed_at_desc&student_list=everyone'
      },
    },
    {
      icon: 'rising',
      title: 'Total Quizzes',
      singular_title: 'Total Quiz',
      primary_metric: TOTAL_QUIZZES,
      lookup_key: YEARLY_TOTAL_QUIZZES,
      yearly_metric: true,
      secondary_metric: TIME_PERIOD,
      link: {
        text: 'View',
        build_link: true,
        base: '/data/everyone/quizzes?order=completed_at_desc&student_list=everyone'
      },
    },
    {
      icon: 'rising',
      title: 'Total Quizzes',
      singular_title: 'Total Quiz',
      primary_metric: 'total_quizzes',
      lookup_key: 'total_quizzes',
    },
    {
      font_color: 'green',
      icon: 'target',
      title: 'students have completed all goals',
      singular_title: 'student has completed all goals',
      primary_metric: GOALS_COMPLETE,
      lookup_key: GOALS_COMPLETE
    },
    {
      font_color: 'yellow',
      icon: 'gear',
      title: 'student(s) are on pace to complete all goals',
      singular_title: 'student is on pace to complete all goals',
      primary_metric: GOALS_ON_PACE,
      lookup_key: GOALS_ON_PACE
    },
    {
      font_color: 'red',
      icon: 'slow',
      title: 'student(s) are behind on completing all goals',
      singular_title: 'student is behind on completing all goals',
      primary_metric: GOALS_BEHIND,
      lookup_key: GOALS_BEHIND,
    },
    {
      icon: 'gauge',
      title: 'Average Lexile',
      singular_title: 'Average Lexile',
      primary_metric: AVERAGE_LEXILE_LEVEL,
      lookup_key: AVERAGE_LEXILE_LEVEL,
      link: {
        text: 'View',
        location: '/data/everyone/books?student_list=everyone'
      },
    },
    {
      icon: 'clock',
      title: 'Mins Logged',
      singular_title: 'Min Logged',
      primary_metric: MINUTES_LOGGED,
      lookup_key: MINUTES_LOGGED,
      link: {
        text: 'View Logs',
        location: '/data/everyone/reading_logs?student_list=everyone'
      },
    },
    {
      font_color: 'green',
      icon: 'books',
      title: 'Total Books',
      singular_title: 'Total Book',
      primary_metric: TOTAL_BOOKS,
      lookup_key: TOTAL_BOOKS,
      yearly_metric: true,
      link: {
        text: 'View',
        location: '/data/everyone/books?student_list=everyone'
      },
    },
    {
      font_color: 'red',
      icon: 'flag',
      title: 'Books Flagged As Not Read',
      singular_title: 'Book Flagged As Not Read',
      primary_metric: FLAGGED_BOOKS,
      lookup_key: FLAGGED_BOOKS,
      link: {
        text: 'View',
        location: '/data/everyone/books?read_book=no'
      },
    },
    {
      icon: 'question-and-answer',
      title: 'Questions',
      singular_title: 'Question',
      primary_metric: TOTAL_PRACTICE_QUESTIONS,
      lookup_key: TOTAL_PRACTICE_QUESTIONS,
      link: {
        text: 'View',
        location: '/data/everyone/practice_questions?student_list=everyone'
      },
    },
    {
      icon: 'star',
      title: 'Reviews',
      singular_title: 'Review',
      primary_metric: TOTAL_REVIEWS,
      lookup_key: TOTAL_REVIEWS,
      link: {
        text: 'View',
        location: '/data/everyone/reviews?student_list=everyone'
      },
    },
    {
      icon: 'pencil',
      title: 'Exercises',
      singular_title: 'Exercise',
      primary_metric: EXCERCISES_COMPLETED,
      lookup_key: EXCERCISES_COMPLETED,
      link: {
        text: 'View',
        location: '/data/everyone/activities?student_list=everyone'
      },
    },
    {
      icon: 'blocks',
      title: 'Question Builders',
      singular_title: 'Question Builder',
      primary_metric: TOTAL_QUESTION_BUILDERS,
      lookup_key: TOTAL_QUESTION_BUILDERS,
      link: {
        text: 'View',
        location: '/data/everyone/question_builders?student_list=everyone'
      },
    },
  ],
  //// STUDENTS ////
  [STUDENT]: [
    {
      icon: 'gauge',
      title: 'Avg Quiz Score',
      singular_title: 'Avg Quiz Score',
      primary_metric: AVERAGE_QUIZ_SCORE,
      lookup_key: AVERAGE_QUIZ_SCORE,
      show_comparison: true,
      link: {
        text: 'View',
        filters: [],
        subject: 'quizzes'
      },
    },
    {
      icon: 'cancel',
      title: 'Failed Quizzes',
      singular_title: 'Failed Quiz',
      primary_metric: FAILED_QUIZZES,
      lookup_key: FAILED_QUIZZES,
      show_comparison: true,
      link: {
        text: 'View',
        filters: ['status=failed'],
        subject: 'quizzes'
      },
    },
    {
      icon: 'flag',
      title: 'Flagged Quizzes',
      singular_title: 'Flagged Quiz',
      primary_metric: FLAGGED_QUIZZES,
      lookup_key: FLAGGED_QUIZZES,
      show_comparison: true,
      link: {
        text: 'View',
        filters: ['status=flagged'],
        subject: 'quizzes'
      },
    },
    {
      icon: 'rising',
      title: 'Total Quizzes',
      singular_title: 'Total Quiz',
      primary_metric: TOTAL_QUIZZES,
      lookup_key: TOTAL_QUIZZES,
      show_comparison: true,
      link: {
        text: 'View',
        filters: [],
        subject: 'quizzes'
      },
    },
    {
      icon: 'gauge',
      title: 'Average Lexile',
      singular_title: 'Average Lexile',
      primary_metric: AVERAGE_LEXILE_LEVEL,
      lookup_key: AVERAGE_LEXILE_LEVEL,
      link: {
        text: 'View',
        filters: [],
        subject: 'books'
      },
    },
    {
      icon: 'clock',
      title: 'Mins Logged',
      singular_title: 'Min Logged',
      primary_metric: MINUTES_LOGGED,
      lookup_key: MINUTES_LOGGED,
      show_comparison: true,
      link: {
        text: 'View',
        filters: [],
        subject: 'reading_logs'
      },
    },
    {
      font_color: 'green',
      icon: 'books',
      title: 'Total Books',
      singular_title: 'Total Book',
      primary_metric: TOTAL_BOOKS,
      lookup_key: TOTAL_BOOKS,
      show_comparison: true,
      link: {
        text: 'View',
        filters: [],
        subject: 'books'
      },
    },
    {
      font_color: 'red',
      icon: 'flag',
      title: 'Books Flagged As Not Read',
      singular_title: 'Book Flagged As Not Read',
      primary_metric: FLAGGED_BOOKS,
      lookup_key: FLAGGED_BOOKS,
      show_comparison: true,
      link: {
        text: 'View',
        filters: ['status=flagged'],
        subject: 'books'
      },
    },
    {
      icon: 'gear',
      title: 'quiz goals complete',
      singular_title: 'quiz goal complete',
      lookup_key: QUIZZES_PASSED_GOAL,      
      show_comparison: true,
      link: {
        text: 'View Quizzes',
        filters: [],
        subject: 'quizzes'
      },
    },
    {
      icon: 'pencil',
      title: 'question goals complete',
      singular_title: 'question goal complete',
      lookup_key: QUESTIONS_GOAL,      
      link: {
        text: 'View Questions',
        filters: [],
        subject: 'practice_questions'
      },
    },
    {
      icon: 'star',
      title: 'review goals complete',
      singular_title: 'review goal complete',
      lookup_key: REVIEWS_GOAL,      
      link: {
        text: 'View Reviews',
        filters: [],
        subject: 'reviews'
      },
    },
    {
      icon: 'blocks',
      title: 'question builder goals complete',
      singular_title: 'question builder goal complete',
      lookup_key: QUESTION_BUILDERS_GOAL,
      link: {
        text: 'View Quest. Builders',
        filters: [],
        subject: 'question_builders'
      },
    },
    {
      icon: 'pencil',
      title: 'exercise goals complete',
      singular_title: 'exercise goal complete',
      lookup_key: EXERCISES_GOAL,
      link: {
        text: 'View Exercises',
        filters: [],
        subject: 'activities'
      },
    },
    {
      icon: 'clock',
      title: 'minutes logged',
      singular_title: 'minute logged',
      lookup_key: MINUTES_GOAL,
      link: {
        text: 'View Reading Logs',
        filters: [],
        subject: 'reading_logs'
      },
    },
    {
      icon: 'clock',
      title: 'days active',
      singular_title: 'day active',
      lookup_key: DAYS_ACTIVE_GOAL,
    },
    {
      icon: 'clock',
      title: 'pages read',
      singular_title: 'page read',
      lookup_key: PAGES_GOAL,
      link: {
        text: 'View Reading Logs',
        filters: [],
        subject: 'reading_logs'
      },
    },
    {
      icon: 'question-and-answer',
      title: 'Questions',
      singular_title: 'Question',
      primary_metric: TOTAL_PRACTICE_QUESTIONS,
      lookup_key: TOTAL_PRACTICE_QUESTIONS,
      show_comparison: true,
      link: {
        text: 'View',
        filters: [],
        subject: 'practice_questions'
      },
    },
    {
      icon: 'star',
      title: 'Reviews',
      singular_title: 'Review',
      primary_metric: TOTAL_REVIEWS,
      lookup_key: TOTAL_REVIEWS,
      show_comparison: true,
      link: {
        text: 'View',
        filters: [],
        subject: 'reviews'
      },
    },
    {
      icon: 'pencil',
      title: 'Exercises',
      singular_title: 'Exercise',
      primary_metric: EXCERCISES_COMPLETED,
      lookup_key: EXCERCISES_COMPLETED,
      show_comparison: true,
      link: {
        text: 'View',
        filters: [],
        subject: 'activities'
      },
    },
    {
      icon: 'blocks',
      title: 'Question Builders',
      singular_title: 'Question Builder',
      primary_metric: TOTAL_QUESTION_BUILDERS,
      lookup_key: TOTAL_QUESTION_BUILDERS,
      show_comparison: true,
      link: {
        text: 'View',
        filters: [],
        subject: 'question_builders'
      },
    },
  ],
}

// DIGEST METRICS //
// this should be replaced by customized
// metrics metric order in user prefs
export var districtAdminDigestMetrics = [
  { [QUIZ_WIDGET]: [NEW_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES, YEARLY_TOTAL_QUIZZES] },
  { [BOOK_WIDGET]: [AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS] },
  { [WRITING_WIDGET]: [TOTAL_PRACTICE_QUESTIONS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, TOTAL_QUESTION_BUILDERS] },
  { [GOALS_WIDGET]: [GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND] },
]

export var schoolAdminDigestMetrics = [
  { [QUIZ_WIDGET]: [NEW_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES, YEARLY_TOTAL_QUIZZES] },
  { [BOOK_WIDGET]: [AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS] },
  { [WRITING_WIDGET]: [TOTAL_PRACTICE_QUESTIONS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, TOTAL_QUESTION_BUILDERS] },
  { [GOALS_WIDGET]: [GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND] },
]

export var teacherDigestMetrics = [
  { [QUIZ_WIDGET]: [NEW_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES, YEARLY_TOTAL_QUIZZES] },
  { [BOOK_WIDGET]: [AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS] },
  { [WRITING_WIDGET]: [TOTAL_PRACTICE_QUESTIONS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, TOTAL_QUESTION_BUILDERS] },
  { [GOALS_WIDGET]: [GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND] },
]

export var studentDigestMetrics = [
  { [QUIZ_WIDGET]: [AVERAGE_QUIZ_SCORE, TOTAL_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES] },
  { [BOOK_WIDGET]: [AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS] },
  { [WRITING_WIDGET]: [TOTAL_PRACTICE_QUESTIONS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, TOTAL_QUESTION_BUILDERS] },
  { [GOALS_WIDGET]: [GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND] },
]

export var SPECIAL_RENDERING = [AVERAGE_LEXILE_LEVEL, AVERAGE_QUIZ_SCORE, MINUTES_LOGGED]
export var SUCCESS_BELOW_COMP = [FAILED_QUIZZES, FLAGGED_QUIZZES, FLAGGED_BOOKS]
export var AVERAGE_METRICS = [AVERAGE_LEXILE_LEVEL, AVERAGE_QUIZ_SCORE]
export var GOAL_METRICS = [QUIZZES_PASSED_GOAL, QUESTIONS_GOAL, REVIEWS_GOAL, EXERCISES_GOAL, MINUTES_GOAL, DAYS_ACTIVE_GOAL, PAGES_GOAL, QUESTION_BUILDERS_GOAL]
export var NON_GOAL_METRICS = [TOTAL_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES, GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND, AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS, TOTAL_PRACTICE_QUESTIONS, TOTAL_QUESTION_BUILDERS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, AVERAGE_QUIZ_SCORE]

export var GOAL_TO_WIDGET_KEY = {
  'answers_count': QUESTIONS_GOAL,
  'quiz_passed_count': QUIZZES_PASSED_GOAL,
  'reviews_count': REVIEWS_GOAL,
  'days_active': DAYS_ACTIVE_GOAL,
  'responses_count': EXERCISES_GOAL,
  'minutes_read': MINUTES_GOAL,
  'question_builder_count': QUESTION_BUILDERS_GOAL,
  'pages_read': PAGES_GOAL,
}


// WEBPACK FOOTER //
// ./modules/lib/widgets/WidgetItemsConfig.js